
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { defaults } from '../defaults';
import { ConfigService } from '@docma-mm-core/config/config.service';
import {joinUrl} from '@docma-mm-core/utils/utils';

@Injectable()
export class BasedataService {

  constructor(protected configService: ConfigService) {
  }

  protected getHeaders(forUpload: boolean = false): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    if (forUpload) {
      headers = defaults.getDefaultUploadHeaders();
    } else {
      headers = defaults.getDefaultHeaders();
    }
    return headers;
  }

  protected getFullUrl(appRelativeEndpoint: string): string {
    return joinUrl(this.configService.getMmConfig().apiUrl, appRelativeEndpoint);
  }

  protected getError(error: HttpErrorResponse | any) {
    let err;
    if (error instanceof HttpErrorResponse) {
      err = error || {};
    } else {
      err = new HttpErrorResponse(error);
    }
    return err;
  }

  protected handleError(error: HttpErrorResponse | any) {
    let err;
    if (error instanceof HttpErrorResponse) {
      err = error || {};
    } else {
      err = new HttpErrorResponse(error);
    }
    return observableThrowError(err);
  }

}
